<!-- Иконка паузы: две вертикальные полоски. -->
<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M8 5h3v14H8V5Zm5 0h3v14h-3V5Z"
      :fill="stroke"
    />
  </svg>
</template>

<script>
export default {
  name: "PauseIcon",

  props: {
    size: {
      type: [Number, String],
      default: 20,
    },
    stroke: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>
